import React from 'react';
import { DSSkeleton } from '@elliemae/ds-skeleton';
import { LEFT_NAVIGATION_DATA_TESTID } from '../../constants/index.js';
import { ItemRenderer } from '../../exported-related/index.js';
import type { DSLeftNavigationT } from '../../react-desc-prop-types.js';
import { StyledLeftContainer } from '../styled.js';

const noShadowStyle = () => () => 'box-shadow: none;';

const CollapsedComponent = () => <DSSkeleton variant="circular" w={24} h={24} />;

interface SkeletonPropsT extends DSLeftNavigationT.ComponentProps {
  item: DSLeftNavigationT.ComponentProps['item'];
  hasBorderBottom?: boolean;
}
export const ItemSkeleton = (props: SkeletonPropsT): JSX.Element => {
  const {
    item,
    hasBorderBottom,
    ctx: { leftNavProps },
  } = props;
  const getOwnerProps = React.useCallback(() => leftNavProps, [leftNavProps]);
  const getOwnerPropsArguments = React.useCallback(() => ({}), []);
  const variant = item?.itemOpts?.skeletonVariant ?? 'item';

  return (
    <ItemRenderer
      item={{
        ...item,
        itemOpts: item?.itemOpts
          ? {
              ...item.itemOpts,
              selectable: false,
              focuseable: false,
              ariaRole: 'menuitem',
              ariaLabel: 'Loading',
            }
          : {},
        CollapsedComponent: variant === 'item' ? CollapsedComponent : null,
      }}
      minHeight={variant === 'item' ? '48px' : '32px'}
      shadowStyle={noShadowStyle}
      hasBorderBottom={hasBorderBottom}
    >
      <StyledLeftContainer
        cols={['38px']}
        gutter="1px"
        pl={0}
        justifyItems="center"
        data-testid={LEFT_NAVIGATION_DATA_TESTID.LEFT_CONTAINER} // https://jira.elliemae.io/browse/PUI-15589
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      >
        {variant === 'item' && <CollapsedComponent />}
      </StyledLeftContainer>
      <DSSkeleton variant="rectangular" mt="2px" mb="15px" w="auto" mr="xs" />
    </ItemRenderer>
  );
};
